const schema = localStorage.getItem("schema");
export const basicFormData = () => ({
  inputData: {
    job_card_no: "",
    remark: "",
    created_by: "",
    updated_by: "",
    is_active: true,
  },
});

export const createPageData = () => {
  const schema = localStorage.getItem("schema");

  const payload = {
    modelName: "dispatcheds",
    schema: schema,
    include: [
      {
        model: "material_intakes",
        as: "intake",
      },
      {
        model: "user_masters",
        as: "dispatched_by_user",
      },
      {
        model: "job_cards",
        as: "job_card",
      },
    ],
  };

  const navigatePage = { back: "/dispatched-list" };

  const headerName = "Dispatched";

  const validationType = "DispatchedCreate";
  const createEndpoint = "/updaterelationaldata  ";
  const updateEndpoint = "/updaterelationaldata  ";
  const getEndpoint = "/getRecords";

  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
  };
};

export const listPageData = () => {
  const schema = localStorage.getItem("schema");

  const payload = {
    modelName: "dispatcheds",
    schema: schema,
    include: [
      {
        model: "material_intakes",
        as: "intake",
        include: [
          {
            model: "material_masters",
            as: "material",
          },
        ],
      },
      {
        model: "user_masters",
        as: "dispatched_by_user",
      },
      {
        model: "job_cards",
        as: "job_card",
      },
    ],
  };

  const columnData = [
    { label: "Sr.no", value: "index" },
    { label: "Dispatched By", value: "dispatched_by_user_full_name" },
    { label: "Intake No", value: "intake.intake_no" },
    { label: "Dispatched Date", value: "dispatch_date" },
    { label: "Remark", value: "remark" },
    { label: "Status", value: "is_active" },
    { label: "Action", value: "actions" },
  ];

  const navigatePage = {
    create: "/dispatched-create",
    edit: "/dispatched-create",
    view: "/dispatched-view",
  };

  const searchfields = [
    "dispatched_by_user.first_name",
    "dispatched_by_user.last_name",
    "intake.intake_no",
    "remark",
    "dispatch_date",
  ];

  const headerName = "Dispatched";
  const endpoint = "/getRecords";
  const exportFileName = "DispatchedData.xlsx";

  return {
    payload,
    navigatePage,
    headerName,
    columnData,
    endpoint,
    searchfields,
    exportFileName,
  };
};

export const exportPageData = {
  modelName: "dispatcheds",
  schema: schema,
  include: [
    {
      model: "material_intakes",
      as: "intake",
    },
    {
      model: "user_masters",
      as: "dispatched_by_user",
    },
  ],

  pagination: { page: 1, pageSize: 10000 },
};
